var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { StringUtils } from '../../utils';
var defaultEqualityFn = function (element, value) { return element === value; };
export var Segmented = function (props) {
    var _a, _b;
    var enabledIndexes = props.options.map(function (o, i) { return (o.disabled ? -1 : i); }).filter(function (i) { return i >= 0; });
    var isEqual = (_a = props.equalityFn) !== null && _a !== void 0 ? _a : defaultEqualityFn;
    var multiple = (_b = props.multiple) !== null && _b !== void 0 ? _b : Array.isArray(props.value);
    var isSelected = function (optionValue) {
        return multiple
            ? Array.isArray(props.value) && props.value.some(function (entry) { return isEqual(entry, optionValue); })
            : isEqual(props.value, optionValue);
    };
    var handleClick = function (optionValue) { return function () {
        if (!multiple) {
            props.onChange(props.enableDeselect && isSelected(optionValue) ? null : optionValue);
            return;
        }
        var current = Array.isArray(props.value) ? props.value : [];
        props.onChange(isSelected(optionValue)
            ? current.filter(function (entry) { return !isEqual(entry, optionValue); })
            : __spreadArray(__spreadArray([], current, true), [optionValue], false));
    }; };
    var move = function (from, step) {
        if (enabledIndexes.length === 0) {
            return;
        }
        var pos = enabledIndexes.indexOf(from);
        var next = enabledIndexes[(pos + step + enabledIndexes.length) % enabledIndexes.length];
        props.onChange(props.options[next].value);
    };
    var containerRef = React.useRef(null);
    var selectedRef = React.useRef(null);
    React.useEffect(function () {
        if (!props.scrollable) {
            return;
        }
        var container = containerRef.current;
        var option = selectedRef.current;
        if (!container || !option) {
            return;
        }
        var target = option.offsetLeft - (container.clientWidth - option.offsetWidth) / 2;
        container.scrollLeft = Math.max(0, target);
    }, [props.scrollable, props.value, props.options.length]);
    var handleKeyDown = function (index) { return function (event) {
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
            event.preventDefault();
            move(index, 1);
        }
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
            event.preventDefault();
            move(index, -1);
        }
    }; };
    return (_jsx("div", __assign({ ref: containerRef, role: multiple ? 'group' : 'radiogroup', "aria-label": props.label, className: StringUtils.combineStrings([
            'localina-segmented',
            props.fullWidth && 'full-width',
            props.scrollable && 'scrollable',
            props.className,
        ]) }, { children: props.options.map(function (option, index) {
            var selected = isSelected(option.value);
            return (_jsx("button", __assign({ ref: selected ? selectedRef : undefined, type: "button", role: multiple ? undefined : 'radio', "aria-checked": multiple ? undefined : selected, "aria-pressed": multiple ? selected : undefined, disabled: option.disabled, tabIndex: multiple || selected ? 0 : -1, className: StringUtils.combineStrings([
                    'localina-segmented__option',
                    selected && 'selected',
                    option.className,
                ]), onClick: handleClick(option.value), onKeyDown: multiple ? undefined : handleKeyDown(index) }, { children: option.label }), index));
        }) })));
};
